/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import uuid from 'uuid/v4';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const PostRelatedLinks = ({ related_links }) => {
  if (related_links) {
    return (
      <ul className="related-links">
        {related_links.map((item) => (
          <React.Fragment key={uuid()}>
            <li>
              <NavLink
                basePath={publicRuntimeConfig.PUBLIC_URL}
                as={`${item?.permalink}`}
                to={`/article?permalink=${item.permalink}`}
                routerStrategy={'next'}
                id={`related-link-${item.id}`}
                dataWithGoogleEvents="true"
                dataGoogleEvents={JSON.stringify({
                  data: {
                    action: 'click',
                    category: 'Article',
                    label: `${item.link}`
                  }
                })}
              >
                {item.title}
              </NavLink>
            </li>
          </React.Fragment>
        ))}
      </ul>
    );
  }

  return null;
};

PostRelatedLinks.defaultProps = {
  related_links: []
};

PostRelatedLinks.propTypes = {
  related_links: PropTypes.array
};

export default PostRelatedLinks;
